import { render } from "./EventCard.vue?vue&type=template&id=72f510f7&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=72f510f7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72f510f7"

export default script